define('presentation/settings/closeAccount/viewModels/accountClosedViewModel',[
    'common/promises/promiseFactory',
    'plugins/router',
    'presentation/common/window/windowControl',
    'settings/navigationConfiguration'
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        let _promiseFactory = new PromiseFactoryConstructor();

        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _router = require('plugins/router');
        const _windowControl = require('presentation/common/window/windowControl');

        self.billingMessageI18nKey = ko.observable('finalInvoiceMessage');
        self.isBillingMessageVisible = ko.observable(true);

        self.navigateToHomePage = () => {
            _windowControl.openHomePage();
        };

        self.redirectToSignIn = () => {
            _router.navigate(_navigationConfiguration.loginPageUrl);
        };

        self.activate = () => {
            return _initialize();
        };

        const _initialize = () => {
            const _routesById = _navigationConfiguration.routesById;
            const currentRouteId = _router.activeInstruction().config.customSettings.routeId;

            switch (currentRouteId) {
                case _routesById.accountClosedFreeTrial.routeId:
                    self.isBillingMessageVisible(false);
                    break;
                case _routesById.accountClosedAch.routeId:
                    self.billingMessageI18nKey('finalInvoiceMessageAch');
                    break;
                case _routesById.accountClosedInvoice.routeId:
                    self.billingMessageI18nKey('finalInvoiceMessageInvoice');
                    break;
                default:
                    self.billingMessageI18nKey('finalInvoiceMessage');
                    break;
            }

            return _promiseFactory.wait();
        };
    };
});

